import React, { FC } from 'react';

import { LocalityReference } from 'app/model/LocalityReference';
import { LocalityTypeStore } from 'app/logic/address/LocalityTypeStore';
import 'app/logic/address/LocalityReferenceRenderer.less';
import { CommaSeparatedList } from 'app/logic/address/CommaSeparatedList';

export interface LocalityReferenceRendererProps {
    localityReference: LocalityReference;
    localityTypeStore: LocalityTypeStore;
}

export const PrimaryContent: FC<LocalityReferenceRendererProps> = ({
    localityTypeStore,
    localityReference,
}) => {
    const primaryName = localityTypeStore.getById(localityReference.type).name;
    const localityName = localityReference.name;

    return (
        <span className="primary" key={primaryName + localityName}>
            <span>{primaryName}</span>
            &nbsp;
            <span>{localityName}</span>
        </span>
    );
};

export const LocalityReferenceRenderer = ({
    localityReference,
    localityTypeStore,
}: LocalityReferenceRendererProps) => {
    return (
        <div className={'localityReferenceRenderer'}>
            <PrimaryContent
                localityReference={localityReference}
                localityTypeStore={localityTypeStore}
            />
            <div className={'secondary'}>
                <CommaSeparatedList
                    values={[
                        { postfix: localityReference.region, reordered: true },
                        {
                            postfix: localityReference.district,
                            prefix: 'район',
                            reordered: true,
                        },
                        {
                            postfix: localityReference.ruralCouncil,
                            prefix: 'сельсовет',
                            reordered: true,
                        },
                    ]}
                />
            </div>
        </div>
    );
};
